import { render, staticRenderFns } from "./NewReservationModal.vue?vue&type=template&id=1a5967d5&scoped=true"
import script from "./NewReservationModal.vue?vue&type=script&lang=js"
export * from "./NewReservationModal.vue?vue&type=script&lang=js"
import style0 from "./NewReservationModal.vue?vue&type=style&index=0&id=1a5967d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5967d5",
  null
  
)

export default component.exports